// TODO: i18n!

(function() {
    'use strict';

var dropdownButton = function ($document, $timeout, $templateCache) {
    return {
        restrict: 'EA',
        replace: true,
        transclude: true,
        scope: {
        },
        template: $templateCache.get('components/dropdownButton.html'),
        link: function (scope, elem, attrs) {

            console.warn('dropdown-button directive is deprecated - please use xms-dropdown.');

            scope.menuOpen = false;

            var timer;

            // close menu on mouseleave
            elem.bind("mouseleave", function(event){
                event.preventDefault();
                event.stopPropagation();
                // the reason for timeout is to not to close it if it jumps from button to menu (*)
                timer = $timeout(function(){
                    scope.menuOpen = false;
                },200);
                return false;
            });

            // Best Practice: Directives should clean up after themselves. You can use elem.on('$destroy', ...) or scope.$on('$destroy', ...) to run a clean-up function when the directive is removed.
            elem.on('$destroy', function() {
                $timeout.cancel(timer);
            });


        }
    };
}

    dropdownButton.$inject = ['$document', '$timeout', '$templateCache'];
	angular.module('app').directive('dropdownButton', dropdownButton);

}());
